module.exports = __webpack_public_path__ + "media/MyAudio_2.9295c731.mp3";